module.exports = __webpack_public_path__ + "img/audience-copy.420d8c4f.svg";